import React, { Component } from "react";
import headerStyles from "./Header.module.css";
import Step from "../step/Step";
import { Box } from "@mui/material";
import { Animated } from "react-animated-css";

const steps = [
  { emoji: "search", name: "Folio de venta" },
  { emoji: "pen-alt", name: "RFC y CP" },
  { emoji: "at", name: "Correo Electrónico" },
  { emoji: "file-alt", name: "Resultado" },
];

export default class Header extends Component {
  render() {
    const { isActive, updateStepActive } = this.props;

    return (
      <>
        <Box
          className={headerStyles.stepsHeader}
          sx={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Step
            steps={steps}
            isActive={isActive}
            updateStepActive={updateStepActive}
          />
        </Box>
        <Box
          className={headerStyles.stepTextMobile}
          // sx={{
          //   display: "flex",
          //   flexDirection: "row",
          //   position: "absolute",
          // }}
        >
          {steps.map((item, i) => {
            return (
              <Animated
              key={`animated-step-${i}`}
                animationIn="fadeInRight"
                animationOut="fadeInLeft"
                isVisible={isActive === i + 1 ? true : false}
                animationInDuration={200}
                // className={headerStyles.stepTextMobile}
                style={
                  isActive === i + 1
                    ? {
                        // display: "flex",
                        // position: "absolute",
                        // justifyContent: "center",
                        // width: "75vw",
                        paddingTop: "60px",
                        textAlign: "center",
                      }
                    : { display: "none" }
                }
              >
                <div>
                  <div className={headerStyles.stepTopText}>
                    Paso {i + 1}/{steps.length}
                  </div>
                  <div className={headerStyles.stepName}>{item.name}</div>
                </div>
              </Animated>
            );
          })}
        </Box>
      </>
    );
  }
}
